angular.module('stack.common.api.queue.QueueService', [
  'global'
])

/**
 * The QueueService service provides the ability to make
 * multiple data calls in a controllable manner.
 *
 * @class QueueService
 * @constructor
 * @module stack.common.api.queue.QueueService
 */
.factory('QueueService', [
  '$q',
  '$timeout',
  'GLOBAL',
  function ($q, $timeout, GLOBAL) {
    'use strict';

    var service = {

      /**
       * An array of items waiting to be processed
       *
       * @property queue
       * @type {Array<*>}
       */
      queue: [],

      /**
       * An array of items that will be processed at
       * a later time
       *
       * @property deferred
       * @type {Object}
       */
      deferred: {
        processing: false,
        getter: null,
        setter: null,
        items: []
      },

      /**
       * The provided items are added to the queue for immediate
       * processing.  If the list of items exceeds the maximum
       * set for concurrant API calls, then the items added to a
       * deferred list.  The deferred list is processed at a
       * later time.
       *
       * @param {Array<*>} items - An array of items to be added to the queue
       * @param {Function} getter - Getter function
       * @param {Function} setter -  Setter function
       * @return {Promise<*>} resulting item
       */
      processQueue: function buildQueue(items, getter, setter) {
        // clear deferred items list before processing
        service.deferred.items = [];
        service.queue = [];

        _.forEach(items, function (obj, index) {
          if (index < GLOBAL.maximumConcurrantCalls) {
            service.queue.push(getter.call(obj.properties.id, getter.filter));
          } else {
            service.deferred.getter = getter;
            service.deferred.setter = setter;
            service.deferred.items.push(obj);
          }
        });

        return $q
          .all(service.queue)
          .then(function (responses) {
            _.forEach(responses, function (response) {
              setter.call(response, setter.payload);
            });
            return responses;
          });
      },

      /**
       * This method uses previously set deferred items
       * as the data source for providing subsequent queue
       * processing calls.  This method will loop with a $timeout
       * delay until all deferred items have been loaded.
       */
      processDeferred: function processDeferred() {
        if (service.deferred.items.length > 0) {
          service.deferred.processing = true;
          service
            .processQueue(service.deferred.items, service.deferred.getter, service.deferred.setter)
            .then(function () {
              if (service.deferred.items.length > 0) {
                $timeout(service.processDeferred, 500);
              }
              return;
            })
            .catch(function (err) {
              console.log(err);
            });
        } else {
          service.deferred.processing = false;
        }
      }

    };
    return service;
  }
]);
